<template>
  <div
    class="das-info-list"
    :class="{
      'das-info-list--align-center': alignType === 'center',
      'das-info-list--align-start': alignType === 'start'
    }"
    :style="`
        --das-info-list-columns: ${columns};
        --das-info-list-columns-sm: ${columnBreakpoints.sm};
        --das-info-list-columns-md: ${columnBreakpoints.md};
        --das-info-list-columns-lg: ${columnBreakpoints.lg};
        --das-info-list-columns-xl: ${columnBreakpoints.xl};
        --das-info-list-columns-2xl: ${columnBreakpoints['2xl']};
      `"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    columns: {
      type: Number,
      default: 4
    },
    columnBreakpointOptions: {
      type: Object,
      default: () => {}
    },
    alignType: {
      /**
       * @enum {string} ['center', 'start']
       */
      type: String,
      default: 'center'
    }
  },
  data: function () {
    return {
      columnBreakpoints: {
        sm: this.columns,
        md: this.columns,
        lg: this.columns,
        xl: this.columns,
        '2xl': this.columns
      }
    }
  },
  created() {
    Object.assign(this.columnBreakpoints, this.columnBreakpointOptions)
  }
}
</script>
<style lang="scss" scoped>
.das-info-list {
  display: grid;
  grid-gap: 10px 0;
  grid-template-columns: repeat(
    var(--das-info-list-columns),
    max-content minmax(auto, max-content)
  );

  &.das-info-list--align-center {
    .das-info-list-label,
    .das-info-list-value,
    .das-info-list-input {
      align-self: center;
    }
  }

  &.das-info-list--align-start {
    .das-info-list-label,
    .das-info-list-value,
    .das-info-list-input {
      align-self: start;
    }
  }
}

@media only screen and (max-width: 640px) {
  .das-info-list {
    grid-template-columns: repeat(
      var(--das-info-list-columns-sm),
      max-content minmax(auto, max-content)
    );
  }
}
@media only screen and (min-width: 640px) {
  .das-info-list {
    grid-template-columns: repeat(
      var(--das-info-list-columns-md),
      max-content minmax(auto, max-content)
    );
  }
}

@media only screen and (min-width: 1024px) {
  .das-info-list {
    grid-template-columns: repeat(
      var(--das-info-list-columns-lg),
      max-content minmax(auto, max-content)
    );
  }
}

@media only screen and (min-width: 1280px) {
  .das-info-list {
    grid-template-columns: repeat(
      var(--das-info-list-columns-xl),
      max-content minmax(auto, max-content)
    );
  }
}

@media only screen and (min-width: 1536px) {
  .das-info-list {
    grid-template-columns: repeat(
      var(--das-info-list-columns-2xl),
      max-content minmax(auto, max-content)
    );
  }
}
</style>
